import { useEffect } from "react";

// Sets the page's robots meta to "noindex, nofollow" while mounted, and restores
// the original value on unmount. Keeps /thank-you and /subscribers out of search
// without leaving a conflicting duplicate robots meta tag.
export function useNoIndex() {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    const created = !meta;
    const previous = meta ? meta.getAttribute("content") : null;

    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex, nofollow");

    return () => {
      if (created) {
        meta.remove();
      } else {
        meta.setAttribute("content", previous);
      }
    };
  }, []);
}
